/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Organization_Has_Open_OrdersInputs */

const en_error_organization_has_open_orders = /** @type {(inputs: Error_Organization_Has_Open_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The customer has open sales orders or an amount still to pay on them: it cannot be archived.`)
};

/**
* | output |
* | --- |
* | "The customer has open sales orders or an amount still to pay on them: it cannot be archived." |
*
* @param {Error_Organization_Has_Open_OrdersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_organization_has_open_orders = /** @type {((inputs?: Error_Organization_Has_Open_OrdersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Organization_Has_Open_OrdersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_organization_has_open_orders(inputs)
});